import React from 'react';

const useCircleValues = (circleDimensions, value) => {
    
  const { center, radius, circumference } = circleDimensions;
  
  const percent = Math.max(0, Math.min(100, Number(value)));
  
  const angleStart = -Math.PI / 2;
  const angleEnd = angleStart + (2 * Math.PI * percent) / 100;
  

  const startX = center + radius * Math.cos(angleStart);
  const startY = center + radius * Math.sin(angleStart);

  const endX = center + radius * Math.cos(angleEnd);
  const endY = center + radius * Math.sin(angleEnd);

  return {
    percent,
    offset: circumference * (1 - percent / 100),
    start: { x: startX, y: startY },
    end: { x: endX, y: endY },
  }
};

export const CircleBackground = ({ radius, center, bgColor, strokeWidth }) => { 
  return <circle
    className="percentage-circle__bg"
    cx={center}
    cy={center}
    r={radius}
    stroke={bgColor}
    strokeWidth={strokeWidth}
    fill="none"
  />;
}

export const CircleProgress = ({ dimensions, value, color, dotColor, strokeWidth }) => { 
  const { percent, offset, start, end } = useCircleValues(dimensions, value);
  const { radius, circumference, center } = dimensions;
  const dotRadius = strokeWidth / 2;

  return <>
    <circle
      className="percentage-circle__progress"
      cx={center}
      cy={center}
      r={radius}
      stroke={color}
      strokeWidth={strokeWidth}
      fill="none"
      strokeDasharray={circumference}
      strokeDashoffset={offset}
      strokeLinecap="round"
      style={{ transition: 'stroke-dashoffset 0.5s ease' }}
      transform={`rotate(-90 ${center} ${center})`}
    />
    <circle cx={start.x} cy={start.y} r={dotRadius} fill={dotColor} style={{ transition: 'stroke-dashoffset 0.5s ease' }} />
    {percent > 0 && (
      <circle cx={end.x} cy={end.y} r={dotRadius} fill={dotColor} style={{ transition: 'stroke-dashoffset 0.5s ease' }} />
    )}
  </>;
}

export const CircleText = ({ radius, value, textColor }) => {
  const percent = Math.round(value);
  return <text
    x="50%"
    y="50%"
    textAnchor="middle"
    dominantBaseline="central"
    fontSize={radius * 0.5}
    fill={textColor}>
    {`${percent}%`}
  </text>
};